import { ProposalState } from "..";

function ClearPendingReducer(state: ProposalState) {
  state.pendingMaterials = [];
}

export default ClearPendingReducer;
